export const WDAC_POLICY_TYPE = {
  BasePolicy: 'BasePolicy',
  SupplementalPolicy: 'SupplementalPolicy',
};

const WDAC_POLICY_TYPE_MAPPING = [
  { value: WDAC_POLICY_TYPE.BasePolicy, label: 'Base Policy' },
  { value: WDAC_POLICY_TYPE.SupplementalPolicy, label: 'Supplemental Policy' },
];

export const getWdacPolicyTypeLabel = value =>
  WDAC_POLICY_TYPE_MAPPING.find(item => item.value === value)?.label ??
  (value != null && value !== '' ? String(value).replace(/([a-z])([A-Z])/g, '$1 $2') : '');

export const getWdacPolicyTypeOptions = () => WDAC_POLICY_TYPE_MAPPING.map(({ value, label }) => ({ value, label }));
